import React from 'react';
import { Controller } from 'react-hook-form';
import CurrencyInput from '../Inputs/CurrencyInput';

const ControlledCurrencyInput = props => {
  const { id, name, control, ...rest } = props;
  return (
    <Controller
      name={name}
      control={control}
      render={({ onChange, value }) => (
        <CurrencyInput
          id={id}
          value={value}
          onValueChange={values => {
            if (values && values.value !== undefined) {
              onChange(values.value);
              return values.value;
            }
            onChange('');
            return '';
          }}
          {...rest}
        />
      )}
    />
  );
};

export default ControlledCurrencyInput;
